import { useEffect } from 'react'

interface DiscountDebuggerProps {
  discountSoftwarePercent: number
  discountServicesPercent: number
}

export default function DiscountDebugger({ discountSoftwarePercent, discountServicesPercent }: DiscountDebuggerProps) {
  useEffect(() => {
    console.log('🎯 DISCOUNT DEBUGGER:', {
      discountSoftwarePercent: `${(discountSoftwarePercent * 100).toFixed(0)}%`,
      discountServicesPercent: `${(discountServicesPercent * 100).toFixed(0)}%`,
      rawSoftware: discountSoftwarePercent,
      rawServices: discountServicesPercent
    })
  }, [discountSoftwarePercent, discountServicesPercent])

  return null
}